var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCrossOriginWorkerURL } from "../../crossoriginworker";
export function createLoadOrReturnBroker(loadBroker, assetsLocation) {
    return __awaiter(this, void 0, void 0, function* () {
        let broker = null;
        const workerUrl = yield getCrossOriginWorkerURL(`${assetsLocation}/timers.worker.js`);
        broker = loadBroker(workerUrl);
        if (workerUrl.startsWith("blob:")) {
            URL.revokeObjectURL(workerUrl);
        }
        return () => {
            return broker;
        };
    });
}
//# sourceMappingURL=load-or-return-broker.js.map